import { useParams } from "common/components/Form/ParamsContext";
import { getRedflagPartnerService } from "./redflagPartnerApi";

export default function useRedflagPartnerList() {
  const params = useParams();
  const scope = undefined;
  const editUrl = `${
    Object.values(scope || {}).filter(v => !!v).length > 0
      ? "redflag-partners/"
      : ""
  }`;
  const service = getRedflagPartnerService();

  return { ...service, params, scope, editUrl };
}
